import { render, staticRenderFns } from "./OverallSalesCard.vue?vue&type=template&id=8f56ed6c&scoped=true"
import script from "./OverallSalesCard.vue?vue&type=script&lang=js"
export * from "./OverallSalesCard.vue?vue&type=script&lang=js"
import style0 from "./OverallSalesCard.vue?vue&type=style&index=0&id=8f56ed6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f56ed6c",
  null
  
)

export default component.exports